<div class="modal-overlay" *ngIf="isVisible">
  <div class="modal-content">
    <h2 class="modal-title">{{ actionType }} Confirmation</h2>
    <textarea
      class="modal-textarea"
      [(ngModel)]="comments"
      placeholder="Enter your comments..."
      rows="4"
    ></textarea>
    <div class="modal-buttons">
      <button class="btn btn-primary btn-confirm" (click)="confirm()">
        OK
      </button>
      <button class="btn btn-secondary btn-cancel" (click)="cancel()">
        Cancel
      </button>
    </div>
  </div>
</div>
